import React from "react";
import CitySelector from "./CitySelector";
import Logo from "./Logo";

const Header = ({ onCitySelect, selectedCity }) => {
  return (
    <header className="bg-white shadow-sm flex justify-between items-center h-16 px-4 sm:px-6 lg:px-8 fixed top-0 left-0 right-0 z-50">
      <Logo />
      <CitySelector onCitySelect={onCitySelect} selectedCity={selectedCity} />
    </header>
  );
};

export default Header;
